<template>
  <div>
    <page-loader
      v-if="loading"
      message="Loading Component Types..."
    ></page-loader>
    <component-type-card
      v-for="componentType in filteredTypes"
      :key="componentType.id"
      :component-type="componentType"
      class="mb-3"
    ></component-type-card>
    <div v-if="!filteredTypes.length && !loading" class="no-results-message">
      <i class="fad fa-question-circle"></i>
      No Component Types Available
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import sortBy from "lodash/sortBy";
import ComponentTypeCard from "@/ComponentTypes/ComponentTypeCard.vue";
import PageLoader from "@/components/PageLoader.vue";
export default {
  components: {
    ComponentTypeCard,
    PageLoader,
  },
  props: {
    includeArchived: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    ...mapState({
      filteredTypes({ componentTypes }) {
        return sortBy(
          componentTypes.filter(ct => this.includeArchived || !ct.archived),
          ({ name }) => (name || "").toLowerCase()
        );
      },
    }),
  },
  async created() {
    this.loading = true;
    await this.fetchComponentTypes();
    this.loading = false;
  },
  methods: {
    ...mapActions(["fetchComponentTypes"]),
  },
};
</script>

<style lang="scss" scoped></style>
